import { useId } from 'react';

interface LightningProps {
  className?: string;
}

export const LightningIcon = (props: LightningProps) => {
  const { className } = props;
  const id = useId(); // Ensures uniqueness across renders
  const gradientId = `lightning-gradient-${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 22"
      className={className}
    >
      <path
        fill={`url(#${gradientId})`}
        d="m4.625 22 .688-9.075L.75 11.621a.2.2 0 0 1-.117-.294L7.375 0l-.688 9.075 4.563 1.304a.2.2 0 0 1 .117.294L4.625 22Z"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="6"
          x2="6"
          y1="0"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B53CE" />
          <stop offset="1" stopColor="#8395F7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const LightningIconMedium = (props: LightningProps) => {
  const { className } = props;
  const id = useId(); // Ensures uniqueness across renders
  const gradientId = `lightning-gradient-${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 40"
      className={className}
    >
      <path
        fill={`url(#${gradientId})`}
        d="m9 40 1.5-16.5-9.054-2.156a1 1 0 0 1-.582-1.554L15 0l-1.5 16.5 9.054 2.156a1 1 0 0 1 .582 1.554L9 40Z"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="12"
          x2="12"
          y1="0"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B53CE" />
          <stop offset="1" stopColor="#6A80F5" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const LightningIconHover = (props: LightningProps) => {
  const { className } = props;
  const id = useId(); // Ensures uniqueness across renders
  const gradientId = `lightning-gradient-${id}`;
  return (
    <svg
      width="48"
      height="70"
      viewBox="0 0 48 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter={`url(#${gradientId})`}>
        <path
          d="M20 61L22 39.55L9.4761 36.6427C8.77708 36.4804 8.47145 35.6565 8.89554 35.0776L28 9L26 30.45L38.5239 33.3573C39.2229 33.5196 39.5286 34.3435 39.1045 34.9224L20 61Z"
          fill="#46C28C"
        />
      </g>
      <path
        d="M21 55L22.5 38.5L13.4462 36.3443C12.7555 36.1799 12.4514 35.3681 12.8641 34.7903L27 15L25.5 31.5L34.5538 33.6557C35.2445 33.8201 35.5486 34.6319 35.1359 35.2097L21 55Z"
        fill="#CFFFEA"
      />
      <defs>
        <filter
          id={gradientId}
          x="0.40166"
          y="0.7"
          width="47.1967"
          height="68.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4.15"
            result="effect1_foregroundBlur_661_7596"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const LightningIconPress = (props: LightningProps) => {
  const { className } = props;
  const id = useId(); // Ensures uniqueness across renders
  const gradientId = `lightning-gradient-${id}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 56"
      className={className}
    >
      <g filter={`url(#${gradientId})`}>
        <path
          fill="#46C28C"
          d="m17 48 1.5-16.5-9.054-2.156a1 1 0 0 1-.582-1.554L23 8l-1.5 16.5 9.054 2.156a1 1 0 0 1 .582 1.554L17 48Z"
        />
      </g>
      <defs>
        <filter
          id={gradientId}
          width="38.645"
          height="56"
          x=".677"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.32549 0 0 0 0 0.862745 0 0 0 0 0.627451 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7236_42131"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_7236_42131"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
